var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('a-input',{staticStyle:{"width":"63%","margin-right":"2%"},attrs:{"type":"text","value":_vm.number},on:{"change":_vm.handleNumberChange}}),_c('span',[_vm._v("RMB")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }